import { Col, Container, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import {
    KWChartContainer,
    RDChartContainer,
    TFChartContainer,
    DAChartContainer,
    TrafficChartContainer,
    GoogleChartContainer,
    IndexedTableByWritingTypeContainer,
} from "src/app/containers";

export interface ISeoMetricsGrid {
    moneySiteId?: number;
    siteOption?: SimpleFormSelectOption;
}

const SeoMetricsGrid = (props: ISeoMetricsGrid) => {
    const { moneySiteId, siteOption } = props;
    const { formatMessage } = useIntl();

    return (
        <Container className="mt-32">
            <Row>
                <h2 className="mt-5">{formatMessage({ id: "analyse.content.title" })}</h2>
                <IndexedTableByWritingTypeContainer
                    moneySiteId={moneySiteId}
                    siteOption={siteOption}
                />
            </Row>
            <Row className="mt-32">
                <Col>
                    <DAChartContainer moneySiteId={moneySiteId} />
                </Col>
                <Col>
                    <RDChartContainer moneySiteId={moneySiteId} />
                </Col>
                <Col>
                    <TFChartContainer moneySiteId={moneySiteId} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <KWChartContainer moneySiteId={moneySiteId} />
                </Col>
                <Col>
                    <TrafficChartContainer moneySiteId={moneySiteId} />
                </Col>
                <Col>
                    <GoogleChartContainer moneySiteId={moneySiteId} />
                </Col>
            </Row>
        </Container>
    );
};

export default SeoMetricsGrid;
